import SimpleCard, { ECardIcon, ICardProperties } from "components/controls/SimpleCard";
import {
    IStopLoss as FAM_IStopLoss
} from "model/FlexibleAttributeModel";

export interface IStopLossProps extends ICardProperties {
    stopLoss: FAM_IStopLoss;
}

const StopLossCard: React.FC<IStopLossProps> = (props) => {
    const { stopLoss } = props;
    return <SimpleCard
        key={stopLoss.id}
        header="SL"
        description={stopLoss.name ?? ""}
        {...props}
    />
}

export default StopLossCard;